var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7077_66057)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4473 8.75195C12.3606 9.37195 13.0006 10.212 13.0006 11.332V13.332H15.0006C15.3673 13.332 15.6673 13.032 15.6673 12.6653V11.332C15.6673 9.87862 13.2873 9.01862 11.4473 8.75195Z",
    fill: "#2B8C34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33268 7.99935C7.80544 7.99935 8.99935 6.80544 8.99935 5.33268C8.99935 3.85992 7.80544 2.66602 6.33268 2.66602C4.85992 2.66602 3.66602 3.85992 3.66602 5.33268C3.66602 6.80544 4.85992 7.99935 6.33268 7.99935Z",
    fill: "#2B8C34"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3339 7.99935C11.8073 7.99935 13.0006 6.80602 13.0006 5.33268C13.0006 3.85935 11.8073 2.66602 10.3339 2.66602C10.0206 2.66602 9.72727 2.73268 9.44727 2.82602C10.0006 3.51268 10.3339 4.38602 10.3339 5.33268C10.3339 6.27935 10.0006 7.15268 9.44727 7.83935C9.72727 7.93268 10.0206 7.99935 10.3339 7.99935Z",
    fill: "#2B8C34"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33333 8.66602C4.55333 8.66602 1 9.55935 1 11.3327V12.666C1 13.0327 1.3 13.3327 1.66667 13.3327H11C11.3667 13.3327 11.6667 13.0327 11.6667 12.666V11.3327C11.6667 9.55935 8.11333 8.66602 6.33333 8.66602Z",
    fill: "#2B8C34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7077_66057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.333984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleAlt);
export default __webpack_public_path__ + "static/media/people_alt.c6d0954d33dd37662d50701b29464b07.svg";
export { ForwardRef as ReactComponent };